import { render, staticRenderFns } from "./ListadoPlanesPagosConceptosUniversidades.vue?vue&type=template&id=3a826134"
import script from "./ListadoPlanesPagosConceptosUniversidades.vue?vue&type=script&lang=js"
export * from "./ListadoPlanesPagosConceptosUniversidades.vue?vue&type=script&lang=js"
import style0 from "./ListadoPlanesPagosConceptosUniversidades.vue?vue&type=style&index=0&id=3a826134&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports